import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL;

export const MakeAuthenticationRequest = async (endpoint, method = 'GET', data = null) => {
  try {
    const storedUser = localStorage.getItem('userData');
    if (!storedUser) {
        localStorage.removeItem('userData');
        throw new Error("User is not authenticated");
      }

    const { authtoken } = JSON.parse(storedUser);

    const config = {
      method: method,
      url: `${apiURL}${endpoint}`,
      headers: {
        'auth-token': `${authtoken}`,
        'Content-Type': 'application/json'
      },
      data: data
    };

    const response = await axios(config);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      localStorage.removeItem('userData');
      window.location.href = '/login';
      throw new Error("Failed to make authenticated request!");

    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      localStorage.removeItem('userData');
      window.location.href = '/login';
      throw new Error(error.response.data.error);
    } else {
      localStorage.removeItem('userData');
      window.location.href = '/login';
      throw new Error("Failed to make authenticated request!");
    }
  }
};


export const MakeRequest = async (endpoint, method = 'GET', data = null) => {
  try {
    const config = {
      method: method,
      url: `${apiURL}${endpoint}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    const response = await axios(config);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to make request with status: " + response.status);
    }
  } catch (error) {
    console.error("Error in MakeRequest:", error);
    throw error;  // Propagate the error to be handled by the calling function
  }
};


export const getUser = async () => {
  return MakeAuthenticationRequest(`user/getuser`);
};

export const getWallet = async () => {
  return MakeAuthenticationRequest(`wallet/getwallet`);
};

export const getTransactionHistory = async (limit = 50, skip = 0) => {
  return MakeAuthenticationRequest(`wallet/transaction-history?limit=${limit}&skip=${skip}`);
};

export const UpdateUser = async (updatedData) => {
  return MakeAuthenticationRequest(`user/update-user`, 'PUT', updatedData);
};

export const getReferrals = async (userId, depthLimit) => {
  const requestBody = {
    userId: userId,
    depthLimit: depthLimit
  };
  return MakeAuthenticationRequest(`referral/getReferrals`, 'POST', requestBody);
};

export const getAllProducts = async (query = '', category = '', page = 1) => {
  return MakeRequest(`product/getallproducts?keyword=${query}&productCategory=${category}&page=${page}`);
};

export const getProductById = async (id) => {
  return MakeRequest(`product/getproductbyid/${id}`);
};

export const getOrderById = async (id) => {
  return MakeAuthenticationRequest(`orders/user/${id}`);
};


export const placeOrder = async ({ userId, shippingInfo, orderItems, paymentInfo }) => {
  try {
    const requestBody = {
      userId,
      shippingInfo,
      orderItems,
      paymentInfo
    };

    const response = await MakeAuthenticationRequest(`orders/place-order`, "POST", requestBody);
    return response; // Return response data
  } catch (error) {
    console.error("Order placement failed:", error);
    throw error; // Rethrow error for handling in components
  }
};

// --- Hybrid activation pins -------------------------------------------------

export const getPinTiers = async () => {
  return MakeRequest(`pin/tiers`);
};

export const retryPinIssue = async (earnedPinId) => {
  return MakeAuthenticationRequest(`pin/retry-issue/${earnedPinId}`, 'POST');
};

export const getMyPins = async () => {
  return MakeAuthenticationRequest(`pin/my-pins`);
};

export const verifyAndUpdatePaymentStatus = async (order_id, razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
  try {
    const requestBody = {
      order_id,
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature
    };
    const response = await MakeAuthenticationRequest('orders/verify-payment', "POST", requestBody);
    return response;
  } catch (error) {
    console.error("VArification failed:", error);
    throw error; 
  }
}
